import { render, staticRenderFns } from "./Preface.vue?vue&type=template&id=463980ca&scoped=true&"
import script from "./Preface.vue?vue&type=script&lang=js&"
export * from "./Preface.vue?vue&type=script&lang=js&"
import style0 from "./Preface.vue?vue&type=style&index=0&id=463980ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463980ca",
  null
  
)

export default component.exports